import { connect } from 'react-redux';
import EndFrame from './endFrame.ui';
import videoActions from '../../state/video/video.actions';

const mapDispatchToProps = (dispatch: any): Object => ({
    endFrameAnimationPlaying(animationPlaying: boolean) {
        dispatch(videoActions.endFrameAnimationPlaying(animationPlaying));
    },

    endFrameAnimationEnded(animationEnded: boolean) {
        dispatch(videoActions.endFrameAnimationEnded(animationEnded));
    },
});

const connectApp = connect(
    null,
    mapDispatchToProps
)(EndFrame);

export default connectApp;
